import { useContext } from "react";

import { SidebarContext, type SidebarContextValue } from "@/components/Sidebar/SidebarContext";

export const useSidebarManager = (): SidebarContextValue => {
  const context = useContext(SidebarContext);

  if (!context) {
    throw new Error("Components should be rendered inside the SidebarContext component");
  }

  return context;
};
